import axios from "axios";
import useAxiosPrivateToken from "../hooks/usePrivateAxios";
import { timeout } from "../helpers/timeout";

interface IPresignedUrlUploadFileDto {
    originalFileName: string;
    fileName: string;
    contentType: string;
    presignedUrl: string;
}

export type UploadFilesApiResultType = {
    isSuccess: boolean;
    message: string;
    list: IPresignedUrlUploadFileDto[];
}

const GET_PRESIGNED_UPLOAD_URL = '/files/get-presigned-url-to-upload-file';


const useFilesApi = () => {

    const { axiosLolatechPrivate, handleError } = useAxiosPrivateToken();

    async function uploadFilesApi(personId: string, files: { file: Blob, name: string }[]): Promise<UploadFilesApiResultType> {

        const result: UploadFilesApiResultType = {
            isSuccess: false,
            message: '',
            list: []
        };

        try {

            const body = {
                personId: personId,
                files: files.map(({ file, name }) => ({
                    fileName: name || 'unknown',
                    contentType: file.type,
                    size: file.size
                }))
            };

            const response = await axiosLolatechPrivate.post(GET_PRESIGNED_UPLOAD_URL, body);

            const data = response.data;

            if (Array.isArray(data) && !data.every(isPresignedUrlUploadFileDto)) {
                result.message = 'קובץ לא עלה לשרת - נתונים לא תקינים';
                return result;
            }

            try {

                for (const file of data) {

                    const blob = files.find(f => f.name === file.originalFileName)?.file;

                    // console.log('****** TEST UPLOADING ******', file.originalFileName, blob);
                    // await timeout(750);
                    
                    await axios.put(file.presignedUrl, blob, {
                        headers: {
                            'Content-Type': file.contentType
                        }
                    });
                }
            } catch (error) {

                console.log('error while uploading file to s3: ', error);
                result.message = 'התרחשה שגיאה במהלך העלאת אחד או יותר מהקבצים לשרת - אנא נסה שוב מאוחר יותר או פנה לתמיכה';
                return result;
            }

            result.isSuccess = true;
            result.message = 'קובץ עולה בהצלחה';
            result.list = data;
        } catch (error) {

            result.isSuccess = false;
            result.message = handleError(error);
        }

        return result;
    }

    return { uploadFilesApi };

    function isPresignedUrlUploadFileDto(obj: any): obj is IPresignedUrlUploadFileDto {

        return obj && typeof obj === 'object' &&
            'originalFileName' in obj && typeof obj.originalFileName === 'string' &&
            'fileName' in obj && typeof obj.fileName === 'string' &&
            'contentType' in obj && typeof obj.contentType === 'string' &&
            'presignedUrl' in obj && typeof obj.presignedUrl === 'string';
    }
}

export default useFilesApi;